export enum OrganizationProfileOperations {
  'GetLogo' = 'GetLogo',
  'SetLogo' = 'SetLogo',
  GetDetails = 'GetDetails',
  UpdateProfile = 'UpdateProfile',
  SaveDateFormat = 'SaveDateFormat',
}
